<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 最新文章</div>-->
    <div class="bgcBox">
      <div class="tabBox">
        <span :class="{bgc:spanNum === 1}" @click="spanNum = 1">最近三天</span>
        <span :class="{bgc:spanNum === 2}" @click="spanNum = 2">最近一周</span>
        <span :class="{bgc:spanNum === 3}" @click="spanNum = 3">最近一个月</span>
      </div>
      <div class="listBox">
        <div class="list" v-for="item in list" :key="item.id">
          <div class="name" @click="yl(item.id)">{{item.title}}</div>
          <div class="caoz">
            <span class="time">{{item.addtime}}</span>
            <span class="chak" @click="yl(item.id)">查看</span>
          </div>
        </div>
      </div>
      <div class="pageBox">
        <span @click="page.pageNum = 1">首页</span>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          layout="prev, pager, next"
          :total="page.pageTotal">
        </el-pagination>
        <span @click="page.pageNum = page.pageCount">尾页</span>
      </div>
    </div>
    <noticeThree v-if="!isDetail" v-bind:idProps="id" v-bind:is-detail="isDetail"
               @watchState="watchState"></noticeThree>
  </div>
</template>

<script>
  import noticeThree from '../../../components/noticeThree'
  export default {
    name: "hszBanKuai",
    data() {
      return {
        spanNum: 1, // tab切换背景
        isDetail: true,  // 预览打开
        list: [],
        page: {
          pageNum: 1,
          pageSize: 20,
          pageTotal: 1,
          pageCount: 1, // 总页数
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if(!this.user){
        this.$router.push("/login")
      }
      this.$emit('setIsAct', 4)
      this.getList()
    },
    methods: {
      // 获取列表
      getList() {
        this.$api.apiAdmin.ArticleList({
          mid: this.user.mid,
          type: this.spanNum,
          page: this.page.pageNum,
          pagesize: this.page.pageSize
        }).then(res => {
          console.log(res)
          this.list = res.data.data
          let List = res.data.data
          List.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 3)
          })
          this.page.pageTotal = res.data.pageinfo.count
          this.page.pageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      // 选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      // 预览
      yl(id) {
        this.id = String(id)
        this.isDetail = false
      },
      // 详情关闭
      watchState(blon) {
        this.isDetail = blon
      },
      // 修改路径
      setPath(){
        this.$router.push({
          path:'/home/zxwzBanKuai',
          query: {
            page: this.page.pageNum
          }
        })
      },
    },
    components: {
      noticeThree
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      spanNum(){
        this.page.pageNum = 1
        this.getList()
      },
      $route(){
        this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background: url("../../../assets/images/xian.png") no-repeat bottom center !important;
    color: #0a2240 !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;
    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }
    .bgcBox {
      width: 100%;
      min-height: 800px;
      padding: 30px;
      background-color: #fff;
      .tabBox {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        span {
          font-size: 18px;
          color: #a9a9a9;
          font-weight: bold;
          padding-bottom: 10px;
          padding-right: 2px;
          margin-left: 5px;
          margin-right: 30px;
          cursor: pointer;
        }
      }
      .listBox {
        width: 100%;
        padding-top: 20px;
        border-top: 1px solid #ececec;
        .list {
          width: 100%;
          padding: 0 20px;
          height: 30px;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          .name {
            width: 900px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #333333;
            background: url("../../../assets/images/Wicon.png") no-repeat left center;
            background-size: 19px 19px;
            padding-left: 30px;
            cursor: pointer;
          }
          .name:hover {
            color: #0a2240;
          }
          .caoz {
            width: 200px;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: flex-end;
            .time {
              font-size: 14px;
              color: #999;
              margin-right: 30px;
            }
            .chak {
              font-size: 14px;
              color: #0a2240;
              cursor: pointer;
            }
          }
        }
      }
      .pageBox {
        margin-top: 80px;
        display: flex;
        justify-content: center;

        span {
          padding: 6px 10px;
          border: 1px solid #f2f2f2;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }

</style>
